<template>
  <div>
    <el-container>
      <el-aside width="auto">
        <sidebar :sidebarWidth="sidebarWidth" class="sidebar"></sidebar>
      </el-aside>
      <el-container>
        <el-header class='header'>
          <breadcrumb @clickNavbar="clickI"></breadcrumb>
        </el-header>
        <el-main class='main'>
          <!-- <router-view></router-view> -->
          <appMain></appMain>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import appMain from './components/appMain.vue'
import breadcrumb from './components/navbar.vue'
import sidebar from './components/sidebar.vue'
  export default{
    data() {
      return{
        sidebarWidth:false
      }
    },
    components:{
      sidebar,breadcrumb,appMain
    },
    methods:{
      clickI(){
        this.sidebarWidth=!this.sidebarWidth
        // console.log(this.sidebarWidth)
      }
    }
  }
</script>

<style scoped>
  .sidebar{
    width: 100%;
  }
  .header{
    display: flex;
    align-items: center;
  }
  .main{
    height: calc(100vh - 60px);
  }
  .el-main{
    padding: 10px;
  }
</style>
